import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import PBMark from '../../Brand/PBMark';

const StyledLogoLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  max-width: 100%;
  color: #111;
  font-size: 0.98rem;
  font-weight: 800;
  letter-spacing: -0.04em;
  text-decoration: none;

  &:hover {
    color: #000;
    text-decoration: none;
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 26rem) {
    gap: .36rem;
    font-size: .88rem;
  }
`;

function Logo() {
  return (
    <StyledLogoLink to="/landing" aria-label="Le Petit Boulot — accueil">
      <PBMark size="2.05rem" />
      <span>Le Petit Boulot</span>
    </StyledLogoLink>
  );
}

export default Logo;
